// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 782 ? "39811124" : chunkId) + "." + {"747":"bca3a439403faa88","782":"520e8efdb8981aec"}[chunkId] + ".js";
};